export const AssetTypesEnum = {
  text: "Text",
  image: "Image",
  video: "Video",
  html5: "HTML5",
};
